import { FC, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Form } from 'antd';
import { isMobile } from 'react-device-detect';
import classNames from 'classnames';

import { FormItem, SubmitButton, TextField } from 'componets/form';
import { Popover } from 'componets/ui';

import { FieldData } from 'models';
import Utils from 'utils/utils';
import { Rules } from 'utils/constants';
import { useAppSelector } from 'hooks';
import { selectIsAdmin } from 'selectors';

import { ReactComponent as InfoIcon } from 'assets/icons/info-grey.svg';

import styles from './index.module.scss';

export const FORM_DATA = [
	{
		name: 'x',
		label: 'bearLossFormFieldOneText',
		info: 'bearLossTooltipFieldOneText',
		mobileLabel: 'bearLossFormFieldOneMobileText',
	},
	{
		name: 'y',
		label: 'bearLossFormFieldTwoText',
		info: 'bearLossTooltipFieldTwoText',
		mobileLabel: 'bearLossFormFieldTwoMobileText',
	},
	{
		name: 'z',
		label: 'bearLossFormFieldThreeText',
		info: 'bearLossTooltipFieldThreeText',
		mobileLabel: 'bearLossFormFieldThreeMobileText',
	},
];
export const BearLossCalculatorForm: FC<{
	onClose: () => void;
	onCalculate: (data: any) => void;
}> = ({ onClose, onCalculate }) => {
	const isAdmin = useAppSelector(selectIsAdmin);

	const { t } = useTranslation();
	const [fields, setFields] = useState<FieldData[]>([]);

	return (
		<Form onFieldsChange={setFields} fields={fields} onFinish={onCalculate}>
			<div className={styles.text}>{t('bearLossCalculatorText')}</div>
			{FORM_DATA.map((item) => {
				return (
					<FormItem
						name={item.name}
						key={item.name}
						rules={[Rules.REQUIRED]}
						normalize={(v) => Utils.transformToFixedNumber(v)}
					>
						<TextField
							label={t(isMobile ? item.mobileLabel : item.label)}
							suffix={
								<Popover
									trigger="hover"
									className={styles.popover}
									content={
										<Trans
											i18nKey={item.info}
											components={{
												list_item: <li />,
												list: <ul />,
											}}
										/>
									}
								>
									<span
										className={styles.suffix}
										onClick={(e) => {
											e.stopPropagation();
										}}
									>
										<InfoIcon />
									</span>
								</Popover>
							}
						/>
					</FormItem>
				);
			})}
			<div className="modal-footer">
				<SubmitButton
					text={t('checkText')}
					className={classNames(styles.submit, { 'ant-btn-grey': isAdmin })}
					classNameWrapper={styles.submitWrapper}
				/>
				<Button type="default" role="button" onClick={onClose} className={styles.cancel}>
					{t('cancelText')}
				</Button>
			</div>
		</Form>
	);
};
